export type MaterialId = 'recyclage' | 'ordures' | 'organiques' | 'verts'

export interface Material {
  id: MaterialId
  label: string
  hint: string
}

export interface Collection {
  id: string
  weekday: string
  date: string
  materials: MaterialId[]
}

/**
 * Windsor collecte trois bacs. Les couleurs ne sont publiées que dans des guides
 * téléchargeables : celles-ci suivent la convention québécoise et restent à confirmer.
 * Les gros rebuts, eux, sont bien ramassés trois vendredis par année.
 */
export const materials: Record<MaterialId, Material> = {
  recyclage: { id: 'recyclage', label: 'Recyclage', hint: 'Bac bleu' },
  ordures: { id: 'ordures', label: 'Ordures', hint: 'Bac noir' },
  organiques: { id: 'organiques', label: 'Compost', hint: 'Bac brun' },
  verts: { id: 'verts', label: 'Gros rebuts', hint: '3 vendredis par année' },
}

export const citizenAddress = '214, rue Saint-Frédéric, Windsor · Secteur 2'

export const quickPrompts = ['Bac non ramassé', 'Prochaine collecte', 'Quel bac sortir ?', 'Autre problème']

export const collections: Collection[] = [
  {
    id: 'sept-15',
    weekday: 'Aujourd’hui',
    date: 'mardi 15 septembre',
    materials: ['ordures', 'organiques', 'recyclage'],
  },
  {
    id: 'sept-22',
    weekday: 'Mardi',
    date: '22 septembre',
    materials: ['ordures', 'organiques'],
  },
  {
    id: 'oct-02',
    weekday: 'Vendredi',
    date: '2 octobre',
    materials: ['verts', 'ordures'],
  },
]

/** Suivi en direct du camion pour la collecte du jour. */
export const liveCollection = {
  material: 'ordures' as MaterialId,
  sector: 'Secteur 2',
  truck: 'Camion 4',
  startedAt: 'Départ du garage à 6 h 45',
  home: [45.566, -71.951] as [number, number],
  /** Trajet du camion, du premier point (déjà parcouru) jusqu’à votre adresse. */
  route: [
    [45.5738, -71.9615],
    [45.5725, -71.9593],
    [45.5713, -71.9575],
    [45.5701, -71.9556],
    [45.5689, -71.9544],
    [45.5681, -71.9531],
    [45.5674, -71.9523],
    [45.5668, -71.9517],
    [45.5663, -71.9513],
    [45.566, -71.951],
  ] as [number, number][],
  /** Avancement initial du camion sur le trajet (0 → 1). */
  startProgress: 0.42,
}
